import { IntakeStatus } from 'types';

const RETRY_API_CALL_NUMBER = 3;
const RETRY_API_CALL_INIT_DELAY = 100;
const RETRY_API_CALL_INCREMENT = 1.5;
const API_CALL_TIMEOUT = 10000;

export { RETRY_API_CALL_NUMBER, RETRY_API_CALL_INIT_DELAY, RETRY_API_CALL_INCREMENT, API_CALL_TIMEOUT };

export const CAS_PROCESS_INTAKE_STATUSES = [IntakeStatus.ACTIVE, IntakeStatus.CLOSED];
export const NOT_INVITED_INTAKE_STATUSES = [IntakeStatus.ACTIVE, IntakeStatus.CLOSED, IntakeStatus.FUTURE];

export const API_CALLS = {
  GET_OFFERS: 'getOffers',
  GET_OFFER: 'getOffer',
  GET_AGENCIES: 'getAgencies',
  GET_AGENTS: 'getAgents',
  GET_CONFIG: 'getConfig',
  GET_COURSES: 'getCourses',
  GET_USERS_STUDENTS: 'getStudentUsers',
  GET_USERS_UNI: 'getUniUsers',
  GET_USERS_AGENTS: 'getAgentUsers',
  GET_USERS_ADMIN: 'getAdminUsers',
  GET_USERS_PARTNER: 'getPartnerUsers',
  GET_USERS_IMMIGRATION_PROVIDER: 'getImmigrationProviderUsers',
  GET_ALL_REGION_CONFIGS: 'getAllRegionConfigs',
  TOGGLE_USER: 'toggleUser',
  GET_PROGRAMMABLE_TAGS: 'getProgrammableTags',
  DELETE_PROGRAMMABLE_TAG: 'deleteProgrammableTag',
  GET_APPLIED_TAGS_NUM: 'getAppliedTagsNum',
  FINGER_APPROVE: 'fingerApprove',
  FINGER_REJECT: 'fingerReject',
  FINGER_RESCIND_APPROVE: 'fingerRescindApprove',
  FINGER_RESCIND_FAIL: 'fingerRescindFail',
  FINGER_RESCIND_PASS: 'fingerRescindPass',
  FINGER_RESCIND_RESIT: 'fingerRescindResit',
  FINGER_DELETE: 'fingerDelete',
  FINGER_ACKNOWLEDGE: 'fingerAcknowledge',
  FINGER_PASS: 'fingerPass',
  FINGER_RESIT: 'fingerResit',
  FINGER_FAIL: 'fingerFail',
  FINGER_CHECK_OFF_RISK: 'fingerCheckOffRisk',
};

export const DEFAULT_STAGE_TAB = 'Post-Deposit';
export const DEFAULT_NOT_INVITES_STAGE_TAB = 'Not-Triggered';

export const PAGE_SIZE = 50;
export const EXPORT_PAGE_SIZE = 1000;

export const INTAKE_ALL_START_DATE = '1980-01-01';
export const INTAKE_ALL_END_DATE = '2040-01-01';

export const FACIAL_RECOGNITION_SCORE_SCALE = 10;

//This is a delay to give enough time for the applicant and application to be created before any actions
export const APPLICANT_REGISTRATION_DELAY = 10000;
